const APP_CONFIG = {
  version: "7.88.0",
  title: "Claire V7.88.0",
  version_client: "7.88.0",
};

export default APP_CONFIG;
